// import './../DetailPage.css';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const NoPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to main page after 3 seconds
        const timer = setTimeout(() => {
            navigate('/collabwithgov'); // Change '/' to your main page route if different
        }, 3000);

        // Cleanup the timer on component unmount
        return () => clearTimeout(timer);
    }, [navigate]);

    return(
        <>
            <Header/>
                <div className="container">
                    <div className="row">
                        <div style={{height:'500px', marginTop:'200px'}}>
                            <h3>Page Not Found</h3>
                            <p>You will be redirected to the main page shortly...</p>
                        </div>
                    </div>
                </div>
            <Footer/>
        </>
    )  
}